/**
 * Classifications allowed to create/host Meetings & Training events.
 * Keep in sync with attendance_events/permissions.py :: EVENT_HOST_CLASSIFICATIONS.
 */
export const EVENT_HOST_CLASSIFICATIONS = new Set([
  'staff',
  'worker',
  'managing_director',
  'executive_director',
  'non_executive_director',
]);

/**
 * Whether the given auth user may create/host attendance events.
 * @param {{ employment_classification?: string } | null | undefined} user
 * @returns {boolean}
 */
export function userCanHostAttendanceEvents(user) {
  const classification = user?.employment_classification;
  return Boolean(classification && EVENT_HOST_CLASSIFICATIONS.has(classification));
}
